import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const SearchSystemTdas = gql`
    query SearchSystemTdas($typeDefinitionIndex: SearchFilterAttributeTypeDefinitionIndex) {
        searchSystems {
            filterTypeDefinitionAttributeList(typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
